import { LastVisitBucket } from "@acto/gql/graphql";
import { EmployeeFilter } from "./EmployeeFilter";
import { LastVisitFilter, type LastVisitRangeValue } from "./LastVisitFilter";
import { RevenueRangeFilter, type RevenueRangeValue } from "./RevenueRangeFilter";

interface CustomerFilterBarProps {
  assignedEmployeeId: string | null;
  onAssignedEmployeeChange: (id: string | null) => void;
  revenueRange: RevenueRangeValue;
  onRevenueRangeChange: (range: RevenueRangeValue) => void;
  lastVisitBucket: LastVisitBucket | null;
  onLastVisitBucketChange: (bucket: LastVisitBucket | null) => void;
  lastVisitRange: LastVisitRangeValue;
  onLastVisitRangeChange: (range: LastVisitRangeValue) => void;
}

export const CustomerFilterBar = ({
  assignedEmployeeId,
  onAssignedEmployeeChange,
  revenueRange,
  onRevenueRangeChange,
  lastVisitBucket,
  onLastVisitBucketChange,
  lastVisitRange,
  onLastVisitRangeChange,
}: CustomerFilterBarProps) => {
  return (
    <>
      <EmployeeFilter value={assignedEmployeeId} onChange={onAssignedEmployeeChange} />
      <LastVisitFilter
        bucket={lastVisitBucket}
        range={lastVisitRange}
        onBucketChange={onLastVisitBucketChange}
        onRangeChange={onLastVisitRangeChange}
      />
      <RevenueRangeFilter value={revenueRange} onChange={onRevenueRangeChange} />
    </>
  );
};
